@if (isMobile()) {
<label class="input rounded-lg border bg-white border-zinc-200 w-full">
  <input
    (click)="handleActionSheet()"
    readonly
    class="placeholder:text-gray-400"
    placeholder="선택"
    [value]="currentLabel()" />
  <app-icon name="material-symbols:arrow-drop-down" class="size-5! text-gray-500" />
</label>
} @else {
<div class="dropdown w-full">
  <div
    tabindex="0"
    role="button"
    class="input rounded-lg border bg-white border-zinc-200 w-full flex items-center justify-between pointer-events-auto">
    <span [class.text-gray-400]="!currentLabel()">
      {{ currentLabel() || '선택' }}
    </span>
    <app-icon name="material-symbols:arrow-drop-down" class="size-5! text-gray-500" />
  </div>
  <ul
    tabindex="0"
    class="dropdown-content menu p-2 shadow-lg bg-base-100 rounded-box w-full z-50 max-h-60 overflow-y-auto flex-nowrap">
    @for (option of options(); track $index) {
    <li>
      <a (click)="handleSelect(option)" [class.active]="option[bindValue()] === value()">
        {{ option[bindLabel()] }}
      </a>
    </li>
    }
  </ul>
</div>
}
